import React, { useState } from 'react'
import PropTypes from 'prop-types'

// Api
import { downloadDocument, downloadEcwt } from 'api/ecwt'

// Constants
import { PATH_ECWT_VIEW } from 'routes/paths'

// Model
import Ecwt from 'models/Ecwt'

// Components
import Text from 'ui/Text'
import Button from 'ui/Button'
import Link from 'ui/Link'

export const ColumnFileNameMobile = ({ row }) => {
  const [loading, setLoading] = useState(false)

  const onDownloadAll = async () => {
    try {
      setLoading(true)
      await Promise.all([
        downloadEcwt(row.fileName),
        downloadDocument(row.fileName),
      ])
    } catch (error) {
      //
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      <div
        className="d-flex justify-content-between align-items-center"
        style={{ margin: '14px 0 3px' }}
      >
        <Text color="#222222" size={13}>
          File name
        </Text>

        {row.isVoid || !row.isAcknowledge ? (
          <Text
            style={{
              cursor: 'not-allowed',
              color: '#C0C4CC',
              textDecoration: 'underline',
              marginRight: '10px',
            }}
          >
            Download
          </Text>
        ) : (
          <Button
            underline
            variant="link"
            loading={loading}
            onClick={onDownloadAll}
            style={{ minHeight: 'auto', marginRight: '10px' }}
          >
            Download
          </Button>
        )}
      </div>

      <Link
        path={PATH_ECWT_VIEW}
        params={{
          id: row.id,
        }}
        style={{ color: '#000000', fontWeight: 'bold', fontSize: '13px' }}
      >
        {row.fileName}
      </Link>
      <Text size={13} paddingTop={3}>
        Acknowledged?
        <span
          style={{
            color: `${row.acknowledgedColor}`,
            paddingLeft: '5px',
          }}
        >
          • {row.acknowledgedText}
        </span>
        {row.isAcknowledge && (
          <span style={{ paddingLeft: '8px' }}>{row.acknowledgeDate}</span>
        )}
      </Text>
      <Text size={13} paddingTop={3}>
        Status
        <span
          style={{
            color: `${row.statusColor}`,
            paddingLeft: '10px',
          }}
        >
          • {row.status}
        </span>
      </Text>
    </div>
  )
}

ColumnFileNameMobile.propTypes = {
  row: PropTypes.instanceOf(Ecwt),
}

ColumnFileNameMobile.defaultProps = {
  row: new Ecwt(),
}

export default ColumnFileNameMobile
